function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1041",
  "data-name": "Group 1041",
  transform: "translate(21403 13296.305)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1038",
  "data-name": "Group 1038",
  transform: "translate(-21402.5 -13295.805)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_482",
  "data-name": "Path 482",
  d: "M311.127-275.438a5.654,5.654,0,0,0-5.652-5.652,5.654,5.654,0,0,0-5.652,5.652v3.113a5.655,5.655,0,0,0,5.652,5.652,5.655,5.655,0,0,0,5.652-5.652Z",
  transform: "translate(-294.601 281.09)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_483",
  "data-name": "Path 483",
  d: "M289.862-241.916l-3.66,1.478a1.4,1.4,0,0,0-.878,1.3v2.454a1.591,1.591,0,0,0,1.591,1.591h18.568a1.591,1.591,0,0,0,1.591-1.591v-2.454a1.4,1.4,0,0,0-.878-1.3l-3.661-1.478",
  transform: "translate(-285.324 256.027)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_678",
  "data-name": "Group 678",
  transform: "translate(-21384 -13285.408)"
}, /*#__PURE__*/React.createElement("path", {
  className: "bottle",
  id: "Path_486",
  "data-name": "Path 486",
  d: "M222.024-169.847a1.5,1.5,0,0,0-1.608-1.371h-6.783a1.5,1.5,0,0,0-1.608,1.371v8.772a1.5,1.5,0,0,0,1.608,1.371h6.783a1.5,1.5,0,0,0,1.608-1.371Z",
  transform: "translate(-212.024 172.79)",
  fill: "#48b05e",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  className: "bottle",
  id: "Path_489",
  "data-name": "Path 489",
  d: "M220.819-176.9H227v-1.547h-6.176Z",
  transform: "translate(-218.907 178.45)",
  fill: "#48b05e",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  className: "bottle",
  id: "Path_492",
  "data-name": "Path 492",
  d: "M220.819-116.419H227v-.387h-6.176Z",
  transform: "translate(-218.907 130.115)",
  fill: "#48b05e",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  className: "bottle",
  id: "Path_495",
  "data-name": "Path 495",
  d: "M212.168-162.192h9.938",
  transform: "translate(-212.137 165.703)",
  fill: "#48b05e",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  className: "bottle",
  id: "Path_498",
  "data-name": "Path 498",
  d: "M212.168-127.273h9.938",
  transform: "translate(-212.137 138.306)",
  fill: "#48b05e",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.75
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_747",
  "data-name": "Path 747",
  d: "M228.8-149.994a8,8,0,0,1,1.087,2.272,1.087,1.087,0,0,1-1.087,1.087,1.087,1.087,0,0,1-1.087-1.087A8,8,0,0,1,228.8-149.994Z",
  transform: "translate(-21607.797 -13129.663)",
  fill: "#fff",
  fillRule: "evenodd"
}));

var SvgMyStock = function SvgMyStock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.375,
    height: 24.967,
    viewBox: "0 0 29.375 24.967",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMyStock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/my-stock.20fd25a9.svg";
export { ForwardRef as ReactComponent };